module.exports = __webpack_public_path__ + "img/p6-p1-text.bbc4b897.png";